export default "__VITE_ASSET__DOZXjiXu__"